import { GET_CUSTOMER, GET_ORDER, GET_PROVIDER, ISSUE_REFUND } from "./order.constants";

export const getOrder = (payload, callback) => ({type: GET_ORDER, payload, callback});
export const getCustomer = (payload, callback) => ({type: GET_CUSTOMER, payload, callback});
export const getProvider = (payload, callback) => ({type: GET_PROVIDER, payload, callback});
export const issueRefund = (payload, callback) => ({type: ISSUE_REFUND, payload, callback});